import PortalAnchorButton from './PortalAnchorButton';

export default PortalAnchorButton;
